import {
  zonePath,
  playlistPath,
  trackPath,
  schedulePath,
  editVoiceMessagePath,
} from '~/common/paths'

export type SearchResultType = 'zone' | 'playlist' | 'track' | 'schedule' | 'voiceMessage'

export function resolveSearchSelectionPath(type: SearchResultType, id: string): string {
  switch (type) {
    case 'zone':
      return zonePath({ zoneId: id })
    case 'playlist':
      return playlistPath({ playlistId: id })
    case 'track':
      return trackPath({ trackId: id })
    case 'schedule':
      return schedulePath({ scheduleId: id })
    case 'voiceMessage':
      return editVoiceMessagePath({ voiceMessageId: id })
  }
}
